










import { Component, Vue, Prop } from "@/common";

@Component({})
export default class TwContainer extends Vue {
  @Prop({ default: "100%" })
  private height: string;

  private currUid: number;

  private currVNode: object;

  private currEvent: object;

  private active: boolean = false;

  private itemSize: number = 0;

  splitDown(e, vnode) {
    this.active = true;
    this.currEvent = e;
    this.currVNode = vnode;
    vnode["hasMoved"] = false;
    if (vnode["direction"] === "vertical") {
      this.itemSize = vnode["height"];
    } else {
      this.itemSize = vnode["width"];
    }
  }

  onMouseUp() {
    this.active = false;
  }
  onMouseMove(e) {
    if (e.buttons === 0 || e.which === 0) {
      this.active = false;
    }

    if (this.active) {
      if (this.currVNode["direction"] === "vertical") {
        this.currVNode["height"] =
          this.itemSize +
          (this.currVNode["region"] === "top"
            ? e.pageY - this.currEvent["pageY"]
            : this.currEvent["pageY"] - e.pageY);
      } else {
        this.currVNode["width"] =
          this.itemSize +
          (this.currVNode["region"] === "left"
            ? e.pageX - this.currEvent["pageX"]
            : this.currEvent["pageX"] - e.pageX);
      }
      this.currVNode["hasMoved"] = true;
    }
    e.preventDefault();
  }
}
